import {AbstractDTO, DateCustom} from "frontend-core";
import {AntiSegmentRule, IAntiSegmentDto} from "@/modules/Segmentation/models/AntiSegmentRule";
import {ValidationRuleResult} from "frontend-core/dist/models/AbstractDTO";
import { IRangeIntRule } from "./SegmentationRules";

export class AntiSegmentRuleDto extends AbstractDTO {
    constructor(
        protected readonly model: AntiSegmentRule,
    ) {
        super(model);

        this.rules = {
            title: () => !!this.model.title || ["Введите название правила"],
            age: () => {
                let res: ValidationRuleResult = true;

                res = (
                    (this.model.age.from === null ||
                        (this.model.age.from >= 16 && this.model.age.from <= 110)
                    )
                    && (this.model.age.to === null ||
                        (this.model.age.to >= 16 && this.model.age.to <= 110)
                    )
                ) || ["Неверный диапазон, возраст водителя от 16 до 110"];

                let errors = this.validateFromLessTo(this.model.age.from, this.model.age.to);

                if (res === true) {
                    res = errors.length === 0 ? true : errors;
                } else {
                    res.concat(errors);
                }

                return res;
            },
            power: () => {
                let res: ValidationRuleResult = true;

                if (this.model.power.to !== null && this.model.power.from !== null) {
                    res = this.model.power.to >= this.model.power.from || ["Неверный диапазон"];
                }

                if (res === true) {
                    res = (
                        (this.model.power.from === null ||
                            (this.model.power.from >= 0 && this.model.power.from <= 10000)
                        )
                        && (this.model.power.to === null ||
                            (this.model.power.to >= 0 && this.model.power.to <= 10000)
                        )
                    ) || ["Неверный диапазон, мощность ТС от 0 до 10000"];
                }

                return res;
            },
            kbm: () => {
                let res: ValidationRuleResult = true;

                if (this.model.kbm.to !== null && this.model.kbm.from !== null) {
                    res = this.model.kbm.to >= this.model.kbm.from || ["Неверный диапазон"];
                }

                if (res === true) {
                    res = (
                        (this.model.kbm.from === null ||
                            (this.model.kbm.from >= 0.46 && this.model.kbm.from <= 3.92)
                        )
                        && (this.model.kbm.to === null ||
                            (this.model.kbm.to >= 0.46 && this.model.kbm.to <= 3.92)
                        )
                    ) || ["Неверный диапазон, КБМ от 0.46 до 3.92"];
                }

                return res;
            },
            coefficientTerritory: () => {
                let res: ValidationRuleResult = true;

                if (this.model.coefficientTerritory.to !== null && this.model.coefficientTerritory.from !== null) {
                    res = this.model.coefficientTerritory.to >= this.model.coefficientTerritory.from || ["Неверный диапазон"];
                }

                if (res === true) {
                    res = (
                        (this.model.coefficientTerritory.from === null
                            || (this.model.coefficientTerritory.from >= 0.5 && this.model.coefficientTerritory.from <= 2)
                        )
                        && (this.model.coefficientTerritory.to === null
                            || (this.model.coefficientTerritory.to >= 0.5 && this.model.coefficientTerritory.to <= 2)
                        )
                    ) || [`Неверный диапазон, КТ от 0.5 до 2`];
                }

                return res;
            },
            periodUse: () => {
                const errors = [
                    ...this.validateIsInteger(this.model.periodUse.from),
                    ...this.validateIsInteger(this.model.periodUse.to),
                    ...this.validateFromLessTo(this.model.periodUse.from, this.model.periodUse.to),
                    ...this.validateRange(this.model.periodUse.from, 3, 12),
                    ...this.validateRange(this.model.periodUse.to, 3, 12),
                    ...this.validateExclusiveIf(this.model.periodUse, this.model.periodDays),
                ]
                
                return errors.length === 0 || errors
            },

            periodDays: () => {
                const errors = [
                    ...this.validateIsInteger(this.model.periodDays.from),
                    ...this.validateIsInteger(this.model.periodDays.to),
                    ...this.validateFromLessTo(this.model.periodDays.from, this.model.periodDays.to),
                    ...this.validateRange(this.model.periodDays.from, 1, 30),
                    ...this.validateRange(this.model.periodDays.to, 1, 30),
                    ...this.validateExclusiveIf(this.model.periodDays, this.model.periodUse),
                ]

                return errors.length === 0 || errors
            },

            usagePeriods: () => {
                let res: ValidationRuleResult = true;

                if (this.model.usagePeriods.to !== null && this.model.usagePeriods.from !== null) {
                    res = this.model.usagePeriods.to >= this.model.usagePeriods.from || ["Неверный диапазон"];
                }

                if (res === true) {
                    res = (
                        (this.model.usagePeriods.from === null ||
                            (this.model.usagePeriods.from >= 3 && this.model.usagePeriods.from <= 12)
                        )
                        && (this.model.usagePeriods.to === null ||
                            (this.model.usagePeriods.to >= 3 && this.model.usagePeriods.to <= 12)
                        )
                    ) || ["Неверный диапазон, период использования от 3 до 12"];
                }

                return res;
            },
            yearManufacture: () => {
                let res: ValidationRuleResult = true;

                if (this.model.yearManufacture.to !== null && this.model.yearManufacture.from !== null) {
                    res = this.model.yearManufacture.to >= this.model.yearManufacture.from || ["Неверный диапазон"];
                }

                const yearNow: number = DateCustom.dateNow.year;

                if (res === true) {
                    res = (
                        (this.model.yearManufacture.from === null ||
                            (this.model.yearManufacture.from >= 1904 && this.model.yearManufacture.from <= yearNow)
                        )
                        && (this.model.yearManufacture.to === null ||
                            (this.model.yearManufacture.to >= 1904 && this.model.yearManufacture.to <= yearNow)
                        )
                    ) || [`Неверный диапазон, год выпуска ТС от 1904 до ${yearNow}`];
                }

                return res;
            },
            driverExperience: () => {
                let res: ValidationRuleResult = true;

                if (this.model.driverExperience.to !== null && this.model.driverExperience.from !== null) {
                    res = this.model.driverExperience.to >= this.model.driverExperience.from || ["Неверный диапазон"];
                }

                if (res === true) {
                    res = (
                        (this.model.driverExperience.from === null ||
                            (this.model.driverExperience.from >= 0 && this.model.driverExperience.from <= 94)
                        )
                        && (this.model.driverExperience.to === null ||
                            (this.model.driverExperience.to >= 0 && this.model.driverExperience.to <= 94)
                        )
                    ) || ["Неверный диапазон, стаж водителя от 0 до 94"];
                }

                return res;
            },
            permittedMass: () => {
                let res: ValidationRuleResult = true;

                if (this.model.permittedMass.to !== null && this.model.permittedMass.from !== null) {
                    res = this.model.permittedMass.to >= this.model.permittedMass.from || ["Неверный диапазон"];
                }

                if (res === true) {
                    const max = 100000;
                    const min = 0;

                    res = (
                        (this.model.permittedMass.from === null ||
                            (this.model.permittedMass.from >= min && this.model.permittedMass.from <= max)
                        )
                        && (this.model.permittedMass.to === null ||
                            (this.model.permittedMass.to >= min && this.model.permittedMass.to <= max)
                        )
                    ) || [`Неверный диапазон, разрешенная масса ТС от ${min} до ${max}`];
                }

                return res;
            },
        };
    }

    /**
     * Проверяет, что заполнено только 1 поле
     * @param mainProperty проверяемое поле
     * @param secondaryProperty поле, которое должно быть пустым
     * @returns Пустой массив, если нет ошибок, или массив с текстом ошибки, если ошибка есть. (не оптимально, но иначе придётся переделать всю валидацию 😭)
     */
    validateExclusiveIf(mainProperty: IRangeIntRule, secondaryProperty: IRangeIntRule): string[] {
        const isMainFilled = mainProperty.from !== null || mainProperty.to !== null;
        const isSecondaryFilled = secondaryProperty.from !== null || secondaryProperty.to !== null;
        if (isMainFilled && isSecondaryFilled) {
            return ["Только один диапазон может быть выбран: месяцы или дни."]
        }
        return [];
    }

    validateFromLessTo(from: number | null, to: number | null): string[] {
        if (to !== null && from !== null) {
            return from < to ? [] : [`Неверный диапазон: "от" (${from}) должно быть меньше "до" (${to})`];
        }

        return [];
    }

    validateIsInteger(value: number | null): string[] {
        if (value !== null) {
            return Number.isInteger(value) ? [] : ["Значение должно быть целым числом."];
        }

        return [];
    }

    validateRange(value: number | null, min: number, max: number): string[] {
        if (value !== null) {
            return value >= min && value <= max ? [] : [`Неверный диапазон, срок страхования от ${min} до ${max}.`];
        }

        return [];
    }

    serialize(): IAntiSegmentDto {
        return {
            title: this.model.title,
            transportType: {
                whiteList: this.model.transportType.whiteList?.length || 0 > 0
                    ? this.model.transportType.whiteList
                    : null,
                isException: this.model.transportType.isException,
            },
            clientType: {
                whiteList: this.model.clientType.whiteList?.length || 0 > 0
                    ? this.model.clientType.whiteList
                    : null,
                isException: this.model.clientType.isException,
            },
            purposeType: {
                whiteList: this.model.purposeType.whiteList?.length || 0 > 0
                    ? this.model.purposeType.whiteList
                    : null,
                isException: this.model.purposeType.isException,
            },
            isMultiDrive: this.model.isMultiDrive,
            carModelException: {
                blackList: this.model.carModelException.blackList?.length || 0 > 0
                    ? this.model.carModelException.blackList
                    : null,
                isException: this.model.carModelException.isException,
            },
            age: this.model.age,
            power: this.model.power,
            kbm: this.model.kbm,
            coefficientTerritory: this.model.coefficientTerritory,
            periodUse: this.model.periodUse,
            periodDays: this.model.periodDays,
            usagePeriods: this.model.usagePeriods,
            yearManufacture: this.model.yearManufacture,
            driverExperience: this.model.driverExperience,
            insurerLastNameException: {
                blackList: this.model.insurerLastNameException?.blackList?.length || 0 > 0
                    ? this.model.insurerLastNameException?.blackList
                    : null,
                isException: this.model.insurerLastNameException.isException,
            },
            ownerLastNameException: {
                blackList: this.model.ownerLastNameException.blackList?.length || 0 > 0
                  ? this.model.ownerLastNameException.blackList
                  : null,
                isException: this.model.ownerLastNameException.isException,
            },
            nameException: {
                blackList: this.model.nameException.blackList?.length || 0 > 0
                  ? this.model.nameException.blackList
                  : null,
                isException: this.model.nameException.isException,
            },
            middlenameException: {
                blackList: this.model.middlenameException.blackList?.length || 0 > 0
                    ? this.model.middlenameException.blackList
                    : null,
                isException: this.model.middlenameException.isException,
            },
            okved: {
                blackList: this.model.okved.blackList?.length || 0 > 0
                    ? this.model.okved.blackList
                    : null,
                isException: this.model.okved.isException,
            },
            permittedMass: this.model.permittedMass,
            clientAddressCode: {
                whiteList: this.model.clientAddressCode.whiteList?.length || 0 > 0
                    ? this.model.clientAddressCode.whiteList
                    : null,
                isException: this.model.clientAddressCode.isException,
            },
            productCode: {
                whiteList: this.model.productCode.whiteList?.length || 0 > 0
                    ? this.model.productCode.whiteList?.map(i => i.value) || []
                    : null,
                isException: this.model.productCode.isException,
            },
            partnerId: {
                whiteList: this.model.partnerId.whiteList?.length || 0 > 0
                    ? this.model.partnerId.whiteList
                    : null,
                isException: this.model.partnerId.isException,
            },
            orgInn: {
                whiteList: this.model.orgInn.whiteList?.length || 0 > 0
                    ? this.model.orgInn.whiteList
                    : null,
                isException: this.model.orgInn.isException,
            },
            isActive: this.model.isActive,
            isMasterRule: this.model.isMasterRule,
            isNotExistVin: this.model.isNotExistVin,
            isForbidRule: this.model.isForbidRule,
            isUseSupplementary: this.model.isUseSupplementary,
        };
    }
}
